module.exports = __webpack_public_path__ + "img/chamada-form-ebook.3a00ace2.png";